import { AppMode } from "constants/enum";

export const getAppMode = () => {
    const appMode = process.env.APP_MODE;

    const isDevMode = appMode === AppMode.DEV;
    const isPreliveMode = appMode === AppMode.PRELIVE;
    const isLiveMode = appMode === AppMode.LIVE;

    return { appMode, isDevMode, isPreliveMode, isLiveMode };
};
